module.exports = __webpack_public_path__ + "img/kefu.c3cdc31c.png";